import emmList from "dummydata/emmList";
import { EMM_TOTAL } from "redux/actionTypes/actionTypes";
import { DELETE_EMM } from "redux/actionTypes/actionTypes";
import { ADD_EMM } from "redux/actionTypes/actionTypes";

const initialState = {
  emmList: [],
  emmTotal: 0,
};

const emmReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_EMM:
      return {
        ...state,
        emmList: action.payload,
      };
      break;
    case DELETE_EMM:
      return {
        ...state,
        emmList: state.emmList.filter(
          (item) => !action.payload.includes(item.key)
        ),
      };
      break;
    case EMM_TOTAL:
      return {
        ...state,
        emmTotal: action.payload,
      };
      break;
    default:
      break;
  }
  return state;
};
export default emmReducer;
